const workflowTemplates = {
  // list screen
  workflow_templates: "Workflow Templates",
  add_template: "Add Template",
  name: "Name",
  trigger: "Trigger",
  steps: "Steps",
  status: "Status",
  actions: "Actions",
  active: "Active",
  inactive: "Inactive",
  edit: "Edit",
  open_builder: "Open builder",
  activate: "Activate",
  delete: "Delete",
  deactivate: "Deactivate",
  no_templates_found: "No workflow templates found",
  no_templates_description:
    "Create a workflow template to start designing an approval flow.",
  search: "Search",
  filters: "Filters",
  all_triggers: "All triggers",
  all_statuses: "All",

  // template dialog
  create_template: "Create Workflow Template",
  edit_template: "Edit Workflow Template",
  create_template_subtitle:
    "Create a workflow template to assign different tasks to different roles in multiple steps",
  edit_template_subtitle: "Rename the template or change what it applies to.",
  template_name: "Workflow Template Name",
  enter_template_name: "Enter Workflow Template Name",
  select_template_type: "Select Trigger",
  template_type_payable_invoice: "Purchase Invoice",
  cancel: "Cancel",
  save: "Save",
  create: "Create",
  template_created_successfully: "Workflow template created successfully",
  template_updated_successfully: "Workflow template updated successfully",
  template_deactivated_successfully:
    "Workflow template deactivated successfully",
  template_activated_successfully:
    "Workflow template activated successfully",
  template_deleted_successfully:
    "Workflow template deleted successfully",
  template_name_required: "Template name is required",
  template_name_max: "Template name must be 150 characters or fewer",
  template_type_required: "Template type is required",
  execution_order: "Execution Order",
  enter_execution_order: "Enter Execution Order",
  execution_order_min: "Execution order cannot be negative",

  // deactivate dialog
  deactivate_template_title: "Deactivate workflow template",
  deactivate_template_description:
    "This template will stop being used for new documents.",
  delete_template_title: "Delete workflow template",
  delete_template_description:
    "This template will be permanently removed from the list. This cannot be undone.",

  // builder — chrome
  back: "Back",
  unsaved_changes: "unsaved changes",
  save_changes: "Save changes",
  saving: "Saving",
  undo: "Undo",
  redo: "Redo",
  graph_saved_successfully: "Workflow saved successfully",
  discard_changes_title: "Discard unsaved changes?",
  discard_changes_description:
    "You have unsaved changes to this workflow. Leaving now will discard them.",

  // builder — add next step
  add_next_step: "Add Next Step",
  next_step_prompt: "What will be the next step?",
  assign_task: "Assign Task",
  assign_task_description: "Create and assign task to a role",
  condition_chooser_description: "Define a condition",
  if_else: "If / else",
  if_else_description: "Splits the flow into a Yes and a No branch",
  condition_needs_setup: "Needs configuration",
  add_condition: "Add Condition",
  condition_not_connected_configure:
    "Condition not connected to any previous step and please configure condition",
  read_only_hint: "You do not have permission to edit this workflow.",

  // builder — nodes
  start: "Start",
  end: "End",
  new_task: "New task",
  new_condition: "New condition",
  no_role_assigned: "No role assigned",
  no_condition_set: "No condition set",
  yes: "Yes",
  no: "No",

  // builder — inspector
  step_details: "Step details",
  step_type_start: "Start",
  step_type_end: "End",
  starts_workflow: "Starts Workflow",
  ends_workflow: "Ends Workflow",
  step_type_user_task: "User task",
  step_type_condition: "If / else",
  step_name: "Name",
  who_is_it_assigned_to: "Who is it assigned to?",
  what_is_the_task: "What is the Task?",
  role: "Role",
  stage: "Stage",
  task_name: "Task name",
  enter_task_name: "Enter task name",
  description_optional: "Description (optional)",
  action: "Action",
  assigned_role: "Assigned role",
  select_role: "Select role",
  required_for_user_tasks: "Required for user tasks",
  assigned_stage: "Stage",
  select_stage: "Select stage",
  assigned_action: "Action",
  select_action: "Select action",
  required_action_for_user_tasks: "Action is required for user tasks",
  description_label: "Description",
  description_placeholder: "Enter a description",
  required_description_for_user_tasks: "Description is required for user tasks",
  evaluate_condition_on_task_completion: "Evaluate condition on task completion",
  remove_step: "Remove step",
  remove_step_title: "Are you sure you want to remove this step?",
  remove_step_description:
    "This step has been configured. Removing it will also delete its connections, and this cannot be undone once you save.",
  condition: "Condition",
  condition_type: "Condition type",
  select_condition_type: "Select condition type",
  parameter: "Field Name",
  select_parameter: "Select Field Name",
  operation: "Operation",
  select_operation: "Select operation",
  value: "Value",
  enter_value: "Enter value",
  start_step_hint: "The flow always begins here. Connect it to your first step.",
  end_step_hint: "The flow finishes here.",
  edit_condition: "Edit condition",
  negate_yes_for_no: "Use opposite of Yes",

  // builder — checks
  checks: "Checks",
  checks_skipped_inactive_template:
    "Checks are skipped while this template is inactive, so you can save an incomplete workflow. Activate the template to enforce them.",
  all_checks_passed: "All checks passed. Ready to save.",
  problems_to_fix_before_saving_one: "1 problem to fix before saving.",
  problems_to_fix_before_saving:
    "{{count}} problems to fix before saving.",
  problems_leading_to_incomplete_workflow_one:
    "Problems leading to incomplete workflow",
  problems_leading_to_incomplete_workflow:
    "{{count}} Problems leading to incomplete workflow",
  warnings_count: "{{count}} warning(s)",
  fix: "Fix",

  // builder — validation messages
  check_start_missing: "The workflow must have a Start step.",
  check_start_multiple: "The workflow can only have one Start step.",
  check_start_has_incoming:
    '"{{name}}" cannot have a previous step.',
  check_start_no_outgoing: '"{{name}}" must have a next step.',
  check_end_missing: "The workflow must have at least one End step.",
  check_end_has_outgoing: '"{{name}}" cannot have a next step.',
  check_end_no_incoming: '"{{name}}" must have a previous step.',
  check_node_no_incoming: '"{{name}}" must have a previous step.',
  check_node_no_outgoing: '"{{name}}" must have a next step.',
  check_usertask_role_missing: 'Task "{{name}}" needs an assigned role.',
  check_usertask_description_missing: 'Task "{{name}}" needs a description.',
  check_usertask_action_missing: 'Task "{{name}}" needs an assigned action.',
  check_condition_branch_count:
    '"{{name}}" must have exactly two outgoing branches (Yes/No).',
  check_condition_branch_missing_condition:
    '"{{name}}" needs a complete condition on every branch.',
  check_condition_branches_identical:
    'The Yes and No branches of "{{name}}" must differ.',
  check_non_condition_edge_has_condition:
    '"{{name}}" is not an If / else step — its outgoing connections cannot carry a condition.',
  check_node_unreachable: '"{{name}}" cannot be reached from Start.',

  // bulk actions
  bulk_limit_exceeded: "Select at most {{max}} templates at a time",
  bulk_activate_title: "Activate workflow templates",
  bulk_activate_description: "Activate {{count}} selected template(s)?",
  bulk_deactivate_title: "Deactivate workflow templates",
  bulk_deactivate_description:
    "{{count}} selected template(s) will stop being used for new documents.",
  bulk_delete_title: "Delete workflow templates",
  bulk_delete_description:
    "{{count}} selected template(s) will be permanently removed from the list. This cannot be undone.",
  templates_activated_successfully: "Workflow templates activated successfully",
  templates_deactivated_successfully:
    "Workflow templates deactivated successfully",
  templates_deleted_successfully: "Workflow templates deleted successfully",
  "workflow-template-ids-required": "Select at least one workflow template.",
  "workflow-template-delete-limit-exceeded":
    "You can delete at most {{0}} workflow templates at once.",
  "workflow-template-status-limit-exceeded":
    "You can activate or deactivate at most {{0}} workflow templates at once.",
  "workflow-template-not-found":
    "These workflow templates were not found: {{0}}",
  "workflow-template-has-pending-tasks":
    "These workflow templates have pending tasks: {{0}}",
  "workflow-template-cannot-activate-no-graph":
    "These workflow templates have no workflow graph and cannot be activated: {{0}}",
  "workflow-template-cannot-activate-graph-invalid":
    '"{{0}}" cannot be activated: {{1}}',

  // errors
  something_went_wrong: "Something went wrong",
  permission_not_granted: "Permission not granted",
  template_not_found: "Workflow template not found",
  trigger_title: "When {{type}} is received",
};

export default workflowTemplates;
